import PropTypes from 'prop-types';
/** @jsx jsx needed to get Storybook to render */
import { css, jsx } from '@emotion/core';
import { graphql, useStaticQuery } from 'gatsby';
import {
  breakpoints,
  colors,
  sectionSettings,
  unitConverter as uc,
} from '../../../../../styles/base';
import ProductCategoryDrawerV1 from '../../../../molecules/ProductCategoryDrawerV1/ProductCategoryDrawerV1';

const ProductCategorySection = ({
  menuSectionConfig,
  productCategorySectionItems,
}) => {
  const query = graphql`
    {
      productCategories: allSanityProductCategoryEntity(
        sort: { fields: productOrdering, order: ASC }
      ) {
        nodes {
          csodId
          displayName
          productOrdering
          shortDescription
          _type
          linkWithoutTitle {
            link {
              ... on SanityRoute {
                id
                routeName
                slug {
                  current
                  _type
                }
              }
            }
          }
        }
      }
    }
  `;

  const { productCategories } = useStaticQuery(query);

  let { backgroundColor } = menuSectionConfig;
  backgroundColor =
    backgroundColor === 'lightGray' ? colors.lightGray.six : colors.white;

  const sectionCss = css`
    width: auto;
    padding-left: ${menuSectionConfig.leftPadding
      ? sectionSettings.menuPadding
      : '0px'};
    background: ${backgroundColor};

    @media (${breakpoints.mobile}) {
      width: 100%;
      padding: ${uc('10px 0')};
    }
  `;

  const productCategoryEntities =
    productCategorySectionItems || productCategories.nodes;

  const renderedComponents = productCategoryEntities.map(data => (
    <ProductCategoryDrawerV1 key={data._key} {...data} />
  ));

  return <div css={sectionCss}>{renderedComponents}</div>;
};

const iconLinkSubheadingShape = {
  image: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  headingText: PropTypes.string,
  subheadingText: PropTypes.string,
  subheadingTextHighlight: PropTypes.string,
  link: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  suiteType: PropTypes.string,
};

ProductCategorySection.propTypes = {
  menuSectionConfig: PropTypes.shape({
    backgroundColor: PropTypes.string,
    leftPadding: PropTypes.bool,
  }),
  productCategorySectionItems: PropTypes.arrayOf(
    PropTypes.shape(iconLinkSubheadingShape)
  ),
};

ProductCategorySection.defaultProps = {
  menuSectionConfig: {
    backgroundColor: colors.white,
    leftPadding: false,
  },
  productCategorySectionItems: [],
};

export default ProductCategorySection;
